var exports = {
  "root": "x1cb7f6e3--9af8a5--root",
  "content": "x1cb7f6e3--9af8a5--content",
  "phone": "x1cb7f6e3--9af8a5--phone",
};

module.exports = exports;
